import * as React from 'react';
import {
  Button,
  TextField,
  Box,
  FormGroup,
  FormLabel,
  FormControlLabel,
  Checkbox,
  Typography,
  Fab,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from '@mui/material';
import './AddAsset3.css';
import {Row,Col} from 'react-bootstrap';
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  Update as UpdateIcon,
  Upload as UploadIcon,
  Close as CloseIcon,
  SaveAlt as SaveAltIcon,
} from '@mui/icons-material';
import ImageUploading from 'react-images-uploading';

const selectedCities = [
  {
    countryCode: 'PK',
    latitude: '24.86080000',
    longitude: '67.01040000',
    name: 'Karachi',
    stateCode: 'SD',
  },
  {
    countryCode: 'PK',
    latitude: '31.55800000',
    longitude: '74.35071000',
    name: 'Lahore',
    stateCode: 'PB',
  },
  {
    countryCode: 'PK',
    latitude: '33.72148000',
    longitude: '73.04329000',
    name: 'Islamabad',
    stateCode: 'IS',
  },
];

export default function AddAsset2Point5({handlePrevious,handleNext,order}) {
  const [images, setImages] = React.useState([]);
  const [captainInfoCount, setCaptainInfoCount] = React.useState(1);
  const [crewCount, setCrewCount] = React.useState(1);

  const onChange = (imageList, addUpdateIndex) => {
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };


  return (
    <div className='addAsset1_Main'>
      <Row>
        <Col sm={12}>
        <input className='Title addAsset2_Input' placeholder='Title' />
        </Col>
        <Col>
        </Col>
      </Row>

      <Row>
        <Col sm={12}>
        <textArea
        style={{width:'80%'}}
        className='Title addAsset2_Input' placeholder='Description' />
        </Col>
      </Row>

      <Row>
      <p className='sleepingTxt'>Upload Pictures</p>
      </Row>


      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        // maxNumber={maxNumber}
        dataURLKey='data_url'
        acceptType={['jpg']}>
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <Box
            className='upload__image-wrapper'
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}>
            <Box>
              <Button
                variant='contained'
                size='small'
                sx={isDragging ? { color: 'red' } : null}
                startIcon={<UploadIcon fontSize='small' />}
                onClick={onImageUpload}
                {...dragProps}>
                Upload
              </Button>
              &nbsp;
              <Button
                size='small'
                className='AdAst2P5RmBtn'
                startIcon={<CloseIcon fontSize='small' />}
                variant='contained'
                disabled={images.length === 0}
                onClick={onImageRemoveAll}>
                Remove all
              </Button>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                overflowX: 'auto',
                overflowY: 'auto',
                maxWidth: '80%',
              }}>
              {imageList.map((image, index) => (
                <Box key={index} className='image-item' sx={{ margin: '10px' }}>
                  <img src={image.data_url} alt='' width='100' />
                  <Box className='image-item__btn-wrapper'>
                    <Fab
                      color='primary'
                      sx={{ margin: '5px' }}
                      onClick={() => onImageUpdate(index)}
                      size='small'>
                      <UpdateIcon fontSize='small'/>
                    </Fab>
                    <Fab
                      sx={{ margin: '5px' }}
                      color='primary'
                      onClick={() => onImageRemove(index)}
                      size='small'>
                      <RemoveIcon fontSize='small'/>
                    </Fab>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </ImageUploading>

      <div className='chngBtnDiv' >
      <button
        className='prevBtn'
        onClick={handlePrevious}
        disabled={order === 0}
        >
        Prev
      </button>
      <button
        className='nextBtn'
        disabled={order === 3}
        onClick={handleNext}
        >
        Next 
      </button>
      </div>
      <br />
    </div>
  );
}
